import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { ColumnProps, Content, alignment, getColumnWidth } from './column';
import cx from 'classnames';
import colors from '../../styles/colors';

export interface Props {
  className?: string;
  onClick?: (any) => void;
  column: ColumnProps;
  item: any;
  offset: number;
}

class Cell extends React.PureComponent<Props> {
  cellContent = (): Content => {
    const { item, column } = this.props;
    if (column.cellContent) {
      return column.cellContent(item);
    }
    if (column.dataAccessor) {
      return column.dataAccessor(item);
    }
    return item[column.dataKey];
  };

  public render() {
    const {
      className,
      onClick,
      column: { cellClassName, sticky, stretch },
    } = this.props;

    return (
      <td
        className={cx(`${className} cell`, { sticky, stretch })}
        onClick={onClick}
      >
        <div className="content-flex-wrapper">
          <div className={`content ${cellClassName || ''}`}>
            {this.cellContent()}
          </div>
        </div>
      </td>
    );
  }
}

export default styled(Cell)`
  position: relative;
  &.sticky {
    position: sticky;
    width: 1px;
    max-width: 1px;
    left: ${({ offset }) => offset}px;
    z-index: 1;
    background: ${colors.grey10o};
    .content {
      width: ${({ column }) => getColumnWidth(column)}px;
      max-width: ${({ column }) => getColumnWidth(column)}px;
    }
  }
  .content-flex-wrapper {
    display: flex;
    flex-flow: row;
    justify-content: ${alignment};
    text-align: ${alignment};
    width: 100%;
    max-width: 100%;
  }
  .content {
    height: 60px;
    display: flex;
    justify-content: ${alignment};
    text-align: ${alignment};
    align-items: center;
    position: relative;
    overflow: hidden;
    width: 100%;
  }
  &:not(.stretch) {
    .content {
      max-width: ${({ column }) => getColumnWidth(column)}px;
    }
  }
`;
